import { BODY } from '../utils';

export default function initMenu() {
  const menuOpener = document.querySelector('[data-menu-opener]');
  const menuDrop = document.querySelector('[data-menu-drop]');
  const activeClass = 'nav--active';

  if (!menuOpener || !menuDrop) return;

  function handler(e) {
    const isTarget = e.target == menuOpener || menuOpener.contains(e.target);

    if (isTarget) {
      BODY.classList.toggle(activeClass);
    } else if (e.target.parentElement !== menuDrop && e.target !== menuDrop) {
      BODY.classList.remove(activeClass);
    }
  }

  BODY.removeEventListener('click', handler);
  BODY.addEventListener('click', handler);
}
